import store from '@/store'

export default {
  install(Vue, options = {}) {
    // console.log('kyPermission install')
    Vue.directive('kyPermission', {
      inserted: (el, binding) => {
        let val = binding.value
        let perms = store.getters.tags
        perms = typeof perms === 'string' ? perms.split(',') : perms
        val = typeof val === 'string' ? val.split(',') : val
        const np = perms.filter(c => val.includes(c))
        // console.log(perms)
        // console.log(val)
        // console.log(np)
        if (np.length === 0) {
          el.parentNode.removeChild(el)
        }
      }
    })
    Vue.directive('removeAria', {//el-radio 会报aria-hidden的错误，使用这个指令就好了
        inserted: (el, binding) => {
            let ariaEls = el.querySelectorAll(".el-radio__original");
            ariaEls.forEach((item) => {
              item.removeAttribute("aria-hidden");
            });
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/directive/index.js